import Link from 'next/link';
import { getEmailErrorMessage, getEmptyPasswordErrorMessage } from 'utils/validators';
import { SocialSignInBlock } from 'components/SocialBlock';
import { HorizontalDivider } from 'components/HorizontalDivider';
import { ServiceAgreement } from 'components/ServiceAggriment';
import { WRONG_EMAIL_NOTIFICATION, EMPTY_FIELD_NOTIFICATION, SIGN_IN_HEADER, SIGN_IN_DESCRIPTION } from 'consts';
import { ResendCode, ResetPhoneSignIn } from 'components/ResendCode';
import { CheckCodeNotification } from 'containers/SignUpPage/CheckCodeNotification';

export const getSignInFields = (redirect?: string) => [
  {
    type: 'title',
    fieldName: 'title',
    value: SIGN_IN_HEADER,
  },
  {
    type: 'description',
    fieldName: 'value',
    value: SIGN_IN_DESCRIPTION,
  },
  {
    type: 'component',
    fieldName: 'social',
    child: <SocialSignInBlock redirect={redirect} />,
  },
  {
    type: 'component',
    fieldName: 'div1',
    child: <HorizontalDivider caption="or" />,
  },
  {
    type: 'notification',
    fieldName: 'loginError',
  },
  {
    type: 'email',
    fieldName: 'email',
    placeholder: 'Email',
    required: true,
    errorMessage: WRONG_EMAIL_NOTIFICATION,
    validator: getEmailErrorMessage,
  },
  {
    type: 'password',
    fieldName: 'password',
    placeholder: 'Password',
    required: true,
    errorMessage: EMPTY_FIELD_NOTIFICATION,
    validator: getEmptyPasswordErrorMessage,
  },
  {
    type: 'component',
    fieldName: 'forget',
    child: (
      <div>
        <Link href="/reset-password">Forget Password?</Link>
      </div>
    ),
  },
  {
    type: 'component',
    fieldName: 'agree',
    child: <ServiceAgreement />,
  },
];

export const getCheckCodeFields = (onResend: () => void, phone: string, changePhoneCallback: () => void) => [
  {
    type: 'title',
    fieldName: 'title',
    value: 'Phone Verification',
  },
  {
    type: 'component',
    fieldName: 'social',
    child: <CheckCodeNotification phone={phone} />,
  },
  {
    type: 'notification',
    fieldName: 'phoneCodeErrors',
  },
  {
    type: 'codeVerification',
    fieldName: 'code',
    required: true,
  },
  {
    type: 'component',
    fieldName: 'resent',
    child: <ResendCode onResend={onResend} changePhoneCallback={changePhoneCallback} />,
  },
  {
    type: 'component',
    fieldName: 'resent',
    child: <ResetPhoneSignIn changePhoneCallback={changePhoneCallback} />,
  },
];
